import { apiRequest } from './index';

export const authAPI = {
  login: (username, password, spaceId) => 
    apiRequest("/auth/login", {
      method: "POST",
      body: { username, password, spaceId },
    }),

  logout: () => 
    apiRequest("/auth/logout", { method: "POST" }),

  getProfile: () => apiRequest("/auth/profile")
};
